import { render, staticRenderFns } from "./ReferencesModal.vue?vue&type=template&id=d044b526&scoped=true&"
import script from "./ReferencesModal.vue?vue&type=script&lang=js&"
export * from "./ReferencesModal.vue?vue&type=script&lang=js&"
import style0 from "./ReferencesModal.vue?vue&type=style&index=0&id=d044b526&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d044b526",
  null
  
)

export default component.exports